import { Grid, GridItem, Paragraph } from '@imported/constellation';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { CONFIRM_CHECKBOX } from '../../components/FormFields/fieldNames.js';
import { CapturePhotoForm, PageHeading } from '../../components/index.js';
import NeedHelp from '../../components/NeedHelp/index.js';
import { proofOfIdentitydefaultValues, } from '../../components/ProofOfIndentityForm/types.js';
import { useIdvProvider } from '../../context/index.js';
import { useLabelContext } from '../../context/LabelContext.js';
import { FAILURE_STATUS } from '../../utils/constants.js';
import { ROUTE_PATHS } from '../../utils/routePaths.js';
const CapturePhoto = () => {
    const { idvState } = useIdvProvider();
    const { getLabelFromContext } = useLabelContext();
    const [disableContinue, setDisableContinue] = useState(false);
    const [pageTitle, setPageTitle] = useState(getLabelFromContext('containers.capturePhoto.pageTitle'));
    const [supportiveText, setSupportiveText] = useState('');
    const errorMessages = getLabelFromContext('errorMessages');
    const { handleSubmit, control, setError, formState: { errors }, } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange',
        defaultValues: proofOfIdentitydefaultValues,
    });
    const navigate = useNavigate();
    const handleCapturePhotoSubmission = useCallback(() => {
        handleSubmit((data) => {
            if (!data.confirmCheckbox) {
                setError(CONFIRM_CHECKBOX, {
                    type: 'custom',
                    message: getLabelFromContext('components.capturePhotoForm.confirmation.error'),
                });
                return;
            }
            navigate(`../${ROUTE_PATHS.SELFIE_DOCUMENT}`);
        })();
    }, [getLabelFromContext, handleSubmit, navigate, setError]);
    const handleRetakePhoto = useCallback(() => {
        if (idvState.identityState.documentOption === '') {
            navigate(`../${ROUTE_PATHS.PROOF_OF_IDENTITY}`);
        }
        else {
            navigate(`../${ROUTE_PATHS.SCAN_DOCUMENT}/${idvState.identityState.documentOption}`);
        }
    }, [navigate, idvState.identityState.documentOption]);
    useEffect(() => {
        const checkPhoto = idvState.capturePhotoResponse;
        if (checkPhoto.response.status === FAILURE_STATUS) {
            setDisableContinue(true);
            if (checkPhoto.response.warnings) {
                const findError = errorMessages.find((el) => el.key === checkPhoto.response.warnings.key) || errorMessages[0];
                setPageTitle(findError.heading);
                setSupportiveText(findError.supportiveText);
            }
        }
        if (!checkPhoto) {
            navigate(`../${ROUTE_PATHS.PROOF_OF_IDENTITY}`);
        }
    }, [
        navigate,
        idvState.identityState.bioMetricCheck,
        setDisableContinue,
        disableContinue,
        errorMessages,
        idvState.capturePhotoResponse,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { journeyTitle: idvState.labels.applicationHeading, pageTitle: pageTitle }),
        React.createElement(Grid, null,
            React.createElement(GridItem, { md: 8, sm: 12 },
                React.createElement(Paragraph, null, supportiveText),
                React.createElement(CapturePhotoForm, { continueFlag: disableContinue, control: control, errors: errors, handleCapturePhotoSubmission: handleCapturePhotoSubmission, handlePreviousPage: handleRetakePhoto })),
            React.createElement(GridItem, { md: 4, sm: 12 },
                React.createElement(NeedHelp, null)))));
};
export default CapturePhoto;
//# sourceMappingURL=index.js.map